import { ID } from '../../utils/codecUtils';
import { processingDurationSchema } from '../models/processingDuration.schema';

export const getProcessingDuration = (annotationId: ID) => {
  return {
    endpoint: `/annotations/${annotationId}/processing_duration`,
    method: 'GET',
    responseSchema: processingDurationSchema,
  } as const;
};
